import React from "react"
import Button from "../../../components/button/button"
import Image from "../../../components/image/image"

const PostCard = ({ blok }) => (
  <div className="post-card gs_reveal">
    {/* Featured Image */}
    <a className="post-card__thumbnail" href={blok.full_slug}>
      {blok.content.featured_image && (
        <Image blok={{ image: blok.content.featured_image }} />
      )}
    </a>

    {/* Media Outlet */}
    <div className="post-card__media-outlet">
      <Button
        blok={{
          Style: "tertiary",
          Label: blok.content.media_outlet,
          content_target: blok.content.external_story_link,
        }}
      />
    </div>

    {/* Title */}
    <h3 className="post-card__title">
      <a href={blok.full_slug}>{blok.name}</a>
    </h3>

    {/* CTA */}
    <Button
      blok={{
        Style: blok.cta_style,
        Label: blok.cta_text,
        content_target: { url: blok.full_slug },
      }}
    />

    {/* First published date */}
    <span className="post-card__date">{blok.first_published_at.replace(/^(\d{4})-(\d{2})-(\d{2}).*/, '$2•$3•$1')}</span>
  </div>
)

export default PostCard
